var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentCheckedFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90625 3.34375V26.9062H16.2734C16.9531 27.9824 17.8594 28.9453 18.8789 29.625H2.90625H0.1875V26.9062V3.34375V0.625H2.90625H19.2188H21.9375V3.34375V11.8965C20.918 12.1797 20.0117 12.5762 19.2188 13.1426V3.34375H2.90625ZM16.5 13.3125V15.748C16.3867 15.8613 16.3301 15.9746 16.2734 16.0312H15.1406H6.98438H5.625V13.3125H6.98438H15.1406H16.5ZM6.98438 7.875H15.1406H16.5V10.5938H15.1406H6.98438H5.625V7.875H6.98438ZM6.98438 18.75H9.70312H11.0625V21.4688H9.70312H6.98438H5.625V18.75H6.98438ZM32.8125 21.4688C32.8125 24.4141 31.2266 27.0762 28.7344 28.5488C26.1855 30.0215 23.0703 30.0215 20.5781 28.5488C18.0293 27.0762 16.5 24.4141 16.5 21.4688C16.5 18.5801 18.0293 15.918 20.5781 14.4453C23.0703 12.9727 26.1855 12.9727 28.7344 14.4453C31.2266 15.918 32.8125 18.5801 32.8125 21.4688ZM29.0742 19.6562L27.8281 18.4102L27.1484 19.0332L23.75 22.4883L22.1074 20.8457L21.4844 20.2227L20.1816 21.4688L20.8047 22.1484L23.0703 24.4141L23.75 25.0371L24.373 24.4141L28.4512 20.3359L29.0742 19.6562Z",
    fill: "#2BAD70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCheckedFilled);
export default __webpack_public_path__ + "static/media/document-checked-filled.3e77aa4d3528613efaa0eef5233c650e.svg";
export { ForwardRef as ReactComponent };